/*
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-06-26 10:44:17
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-07-14 17:25:20
 */
import { createRouter, createWebHistory } from 'vue-router'
import layout from '@/admin/adminhome.vue'
import qtLayout from '@/views/neiye/index.vue'
import Cookies from 'js-cookie'
import { backToLogin, backToHome } from '../utils/login.js'

const routes = [
  {
    path: '/admin',
    meta: { keepAlive: false },
    component: () => import('@/admin/login/index.vue')
  },
  {
    path: '/shujuguanlihome',
    meta: { keepAlive: false },
    component: () => import('@/admin/pages/shujuguanli/views/shujuguanlihome.vue')
  },
  {
    path: '/:cathchAll(.*)',
    name: '404',
    // 不需要登录
    meta: { keepAlive: false, needLogin: false },
    component: () => import('../../public/404/404.vue')
  },
  {
    path: '/',
    meta: { keepAlive: false },
    component: () => import('@/views/home.vue')
  },

  {
    path: '/list',
    meta: { keepAlive: false },
    component: () => import('@/views/neiye/list.vue')
  },
  {
    path: '/detail',
    meta: { keepAlive: false },
    component: () => import('@/views/neiye/detail.vue')

  },
  {
    path: '/search',
    meta: { keepAlive: false },
    component: () => import('@/views/neiye/search.vue')

  },

  // 数据管理中心系统
  {
    path: '/shujuguanli',
    redirect: '/shujuguanli/shujuguanlihome',
    meta: { keepAlive: false },
    component: layout,
    children: [
      // 首页
      {
        path: '/shujuguanli/shujuguanlihome',
        meta: { keepAlive: false },
        // component: () => import('@/pages/shujuguanli/views/shujuguanlihome.vue')
        component: () => import('@/admin/pages/shujuguanli/views/shujuguanlihome.vue')

      },
      // PC教师菜单（菜单管理）
      {
        path: '/shujuguanli/gonggongshuju/menu',
        meta: { keepAlive: false },
        component: () => import('@/admin/pages/fuzhujuecezhichi/views/menus/menu.vue')
      },
      {
        // 系统信息
        path: '/shujuguanli/gonggongshuju/xitongxinxi',
        meta: { keepAlive: false },
        // component: () => import('@/pages/shujuguanli/views/gonggongshuju/xitongxinxi/list.vue')
        component: () => import('@/admin/pages/shujuguanli/views/gonggongshuju/xitongxinxi/list.vue')

      },
      {
        // 用户
        path: '/shujuguanli/gonggongshuju/yonghu',
        meta: { keepAlive: false },
        // component: () => import('@/pages/shujuguanli/views/gonggongshuju/yonghu/list.vue')
        component: () => import('@/admin/pages/shujuguanli/views/gonggongshuju/yonghu/list.vue')

      }

    ]
  },
  // 网站管理
  {
    path: '/wangzhanguanli',
    redirect: '/wangzhanguanli/wangzhanguanli',
    meta: { keepAlive: false },
    component: layout,
    children: [
      {
        // 栏目管理
        path: '/wangzhanguanli/lanmuguanli',
        meta: { keepAlive: false },
        component: () => import('@/admin/pages/wangzhanguanli/views/lanmuguanli/list.vue')
      },
      {
        // 内容管理
        path: '/wangzhanguanli/neirongguanli',
        meta: { keepAlive: false },
        component: () => import('@/admin/pages/wangzhanguanli/views/neirongguanli/list.vue')
      },
      {
        // 首页布局
        path: '/wangzhanguanli/shouyebuju',
        meta: { keepAlive: false },
        component: () => import('@/admin/pages/wangzhanguanli/views/shouyebuju/list.vue')
      }

    ]
  }

]
const router = createRouter({
  // history: createWebHashHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload()
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
})

router.beforeEach((to, from, next) => {
  const token = Cookies.get('access_token')
  const whiteList = ['/', '/admin', '/list', '/detail']
  // console.log(to.path)
  if (whiteList.includes(to.path)) {
    // 在免登录白名单，直接进入
    next()
  } else if (token) {
    if (to.path === '/admin') {
      backToHome()
    } else {
      next()
    }
  } else {
    if (to.path === '/admin') {
      next()
    } else {
      backToLogin()
    }
  }
})
export default router
